module.exports = __webpack_public_path__ + "static/media/donate.bb580827.svg";